// This file is generated.
export const LIB_VERSION = "0.0.232";
